import { createContext } from 'react';

export const SearchRandomizedFeedsContext = createContext(null);

export const EMPTY_SEARCH_RANDOMIZED_FEED = Object.freeze({
  hasRequested: false,
  loading: false,
  data: [],
  error: null,
});

export function getSearchRandomizedFeedState(feeds, feedKey) {
  return feeds[feedKey] ?? EMPTY_SEARCH_RANDOMIZED_FEED;
}
